import React from 'react'
import { renderWithRoot } from '../common/react-root-helper'
import { getState, subscribe } from '../store'
import appActions from '../actions/app'
import { getCarts, getDealers } from './actions'
import App from '../common/app'
import Carts from './components/index'
let unsubscribe = function () {}

function render () {
  renderWithRoot(
    <App active="cart" {...getState()} {...appActions}>
      <Carts {...getState().carts} />
    </App>,
    document.querySelector('#app')
  )
}

export function enter (context, next) {
  unsubscribe = subscribe(render)
  getDealers()
  getCarts()
  render()
}

export function exit (context, next) {
  unsubscribe()
  next()
}
